import { useI18n } from 'vue-i18n';
import { useYupValidation } from '@future-harry/nxt-styles';
import { useLiveEditorStore } from '@/modules/live-editor/stores/live-editor.store';
import { storeToRefs } from 'pinia';
import type { ObjectSchema } from 'yup';

export function useBlockEdit(schema: ObjectSchema<any>) {
   const { t } = useI18n();
   const blockStore = useLiveEditorStore();
   const { editingBlock, draftData } = storeToRefs(blockStore);

   const { errors, validate } = useYupValidation({
      schema,
      data: draftData as any,
   });

   const handleSave = () => {
      const res = validate();
      if (!res.isValid) return notifyError({ title: t('live-editor.content-blocks.fix-errors') });
      blockStore.saveEditing();
   };

   const handleRemove = () => {
      if (!editingBlock.value) return;
      blockStore.removeBlock(editingBlock.value.id);
   };

   const handleDiscard = () => {
      blockStore.discardEditing();
   };

   return {
      errors,
      handleSave,
      handleRemove,
      handleDiscard,
      ...storeToRefs(blockStore),
   };
}
